import React, { ReactElement } from 'react';
import {
  Component, FilterCombo, noDataDropDownRender, Position,
} from "puzzle";
import { Field } from "../../../../../UI/Field/Field";
import { ComboBoxChangeEvent, ComboBoxFilterChangeEvent, ListItemProps } from "@progress/kendo-react-dropdowns";
import _, { get } from "lodash";
import virtualScroll from "../../../../../VirtualScroll";
import { PROPS, STATE, RESPONSE_DATA, USER, FETCHED_USER } from "./Types";

export class AssignDialogDropdown extends Component <PROPS, STATE> {
  initialPaginationData = {
    data: [],
    pageDataPopulated: [],
    pageNumber: 0,
    skip: 0,
    total: 0
  };

  gridRef: any;

  public state: STATE = {
    ...this.initialPaginationData,
    filter: '',
    requestInProgress: false,
    value: undefined
  };

  static defaultProps: PROPS = {
    autoPopulate: false,
    disabled: true,
    includeRacu: false,
    name: 'organizationUser',
    noDataTranslationKey: 'searching',
    onDropdownChangeParent: (name: string, value: USER) => {
    },
    onDropdownFocus: () => {
    },
    pageSize: 10,
    projectId: 0,
    requestActionName: 'getUsersAssignDialog',
    sourceLanguageLocale: "",
    targetLanguageLocale: "",
    value: null,
    virtualScroll: {}
  };

  moduleDidMount() {
    if (this.props.supplierValue === undefined) { // Checking if its undefined so it is only called on first Combo Box
      this.updatePaginationData();
    }
  }

  componentDidUpdate(prevProps: PROPS) {
    if (this.props.supplierValue && !_.isEqual(this.props.supplierValue, prevProps.supplierValue)) { // Can be done this way because only undefined is being passed to above Filter Combo
      this.updatePaginationData(this.props.autoPopulate)
    }
  }

  /**
   * Sets first supplier from supplier list as selected
   */
  autoPopulateSupplier = (): void => {
    this.handleChange({ value: this.state.data[0] } as ComboBoxChangeEvent);
  };

  /**
   * Sets grid data (virtualScrolling)
   * @param data
   */
  setGridData = (data: RESPONSE_DATA) => {
    let { users = [], gridContentInfo } = data;
    users = users.map((item: USER) => {
      const { firstName, lastName } = item;
      return {
        ...item,
        fullName: `${firstName} ${lastName}`
      } as FETCHED_USER
    });

    const repackedData = {
      gridContentInfo,
      items: users
    };

    this.props.virtualScroll.setGridData(repackedData);
  };

  /**
   * Render custom element for dropdown menu item
   */
  itemRender = (li: ReactElement<HTMLLIElement>, itemProps: ListItemProps): ReactElement => {
    const { firstName, lastName } = itemProps.dataItem;
    let textItem = firstName && lastName ? `${firstName} ${lastName}` : this.translate('loading');
    return React.cloneElement(
      li,
      {
        ...li.props,
        id: itemProps.id?.substr(7, itemProps.id?.length)
      },
      textItem
    );
  };

  /**
   * If data still isn't loaded sets fake values.
   * @param data
   */
  prepareDataForDisplay = (data: FETCHED_USER[]) => {
    let mappedData = data.map((item) => {
      if (!get(item, 'firstName')) {
        return {
          ...item,
          firstName: '',
          fullName: '',
          lastName: '',
          userId: 0
        }
      } else return item
    });
    return mappedData;
  };

  /**
   * Filter Change handler (Is being debounced)
   * @param event
   */
  filterChange = (event: ComboBoxFilterChangeEvent): void => {
    this.setState({
      ...this.initialPaginationData,
      filter: event.filter.value
    }, this.updatePaginationData)
  };

  /**
   * updates filtering dispatch action.
   */
  updatePaginationData = (autoPopulate = false): void => {
    this.dispatch(this.props.requestActionName, Position.end, this.prepareRequestParams(0, autoPopulate));
  }


  /**
   * Updates state of parent component (dialog).
   * @param event
   */
  handleChange = (event: ComboBoxChangeEvent): void => {
    this.props.onDropdownChangeParent(this.props.name, event.value);
  };

  /**
   * Prepare params for combo action request
   */
  prepareRequestParams = (pageNumber: number, autoPopulate: boolean): {
    autoPopulate: boolean,
    moduleId: string | undefined,
    url: string
  } => {
    const {
      pageSize,
      projectId,
      moduleId,
      supplierValue,
      includeRacu,
      sourceLanguageLocale,
      targetLanguageLocale
    } = this.props;
    const { filter: fullName } = this.state;
    let url: string = `/projects/${projectId}/users/search?pageSize=${pageSize}&pageNumber=${pageNumber}&fullName=${fullName}&userType=`;
    let restOfUrl: string = includeRacu ? 'organization,client_user' : 'organization';
    if (supplierValue) {
      restOfUrl = `vendor&supplierId=${supplierValue.supplierId}&targetLanguageLocal=${targetLanguageLocale}&sourceLanguageLocal=${sourceLanguageLocale}`;
    }
    url += restOfUrl;
    return {
      autoPopulate,
      moduleId,
      url
    };
  };

  renderBody() {
    const { data, skip, total } = this.state;
    const { pageSize, value, disabled, onDropdownFocus, name, noDataTranslationKey, virtualScroll } = this.props;
    let displayData: FETCHED_USER[] = data.slice(skip, skip + pageSize);
    displayData = this.prepareDataForDisplay(displayData);

    return (
      <Field>
        <FilterCombo
          disabled={disabled}
          onFocus={() => {
            onDropdownFocus(name);
            this.setState({ filter: '' }, () => this.updatePaginationData());
          }}
          label={this.translate(name)}
          ref={(el) => this.gridRef = el}
          data={displayData}
          filterable={true}
          filterChange={_.debounce(this.filterChange, 300)}
          itemRender={this.itemRender}
          listNoDataRender={() => noDataDropDownRender(this.translate(noDataTranslationKey))}
          name='organizationUser'
          onChange={this.handleChange}
          onPageChange={virtualScroll.pageChange}
          popupSettings={{ className: 'pd-assign-dropdown' }}
          textField="fullName"
          translateMethod={this.translate.bind(this)}
          valueField="userId"
          value={value}
          valueAsSimpleType={true}
          virtual={{
            pageSize: pageSize,
            skip: skip,
            total: total
          }}
        />
      </Field>
    );
  }
}

export default virtualScroll(AssignDialogDropdown);
